import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IOrthodonticReferral } from "../models/IOrthodonticReferral";
import { IPage } from "../models/IPage";
import { objectToQueryString } from "../helpers/ApiHelper";

export class OrthodonticReferralProvningskonsultApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getOrthodonticReferral(pagingParams: IPage, success: (data: IPaginatedResponse<IOrthodonticReferral[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(pagingParams);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/orthodonticReferralProvningskonsult?${queryString}`, success, error, final);
    }
}